// src/components/ScrollToTop.jsx

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  // Extrai o pathname (ex: "/encomendas", "/assinatura") do objeto de localização
  const { pathname } = useLocation();

  // Este efeito será executado toda vez que o 'pathname' mudar
  useEffect(() => {
    // Rola a janela para o topo (posição 0, 0)
    window.scrollTo(0, 0);
  }, [pathname]); // O array de dependências garante que o efeito só rode na mudança de rota

  // Este componente não renderiza nada na tela, ele apenas executa um efeito
  return null;
}
